import { Trans, useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { Box, ButtonV2 } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { useRsvpData, useRsvpState } from '../../guest-rsvp.context';
import componentStyles from '../substep.style';
import { getThemeProperties } from '@bridebook/web/lib/wedding-website/utils/get-theme-properties';
import getWebsiteUrl from '@bridebook/web/lib/rsvp/utils/get-website-url';
import { useSearchParams, ReadonlyURLSearchParams } from 'next/navigation';
import SubmitButtonDesktopWrapper from '../../partials/submit-button-desktop-wrapper';
import SubmitButtonMobileWrapper from '../../partials/submit-button-mobile-wrapper';
import GuestRsvpHeader from '../../partials/header';

interface IGoToWebsiteButtonProps {
  websiteId: string;
  searchParams: ReadonlyURLSearchParams | null;
  children: React.ReactNode;
}

const GoToWebsiteButton: React.FC<IGoToWebsiteButtonProps> = ({
  websiteId,
  searchParams,
  children,
}) => (
  <Link href={getWebsiteUrl(websiteId, searchParams ?? undefined)}>
    <ButtonV2>{children}</ButtonV2>
  </Link>
);

const DeadlinePassedStep = () => {
  const { t } = useTranslation('weddingWebsite');
  const searchParams = useSearchParams();
  const { weddingWebsite, theme } = useRsvpData();
  const { websiteId, isPreview } = useRsvpState();

  const partners = weddingWebsite.wedding.partners;

  const themeProperties = useMemo(() => getThemeProperties(theme), [theme]);
  const styles = useMemo(
    () => componentStyles(themeProperties, isPreview),
    [themeProperties, isPreview],
  );

  return (
    <>
      <Box style={styles.substepWrapper}>
        <GuestRsvpHeader />
        <Box style={styles.deadlinePassed.infoWrapper}>
          <Trans
            values={{ partners }}
            ns="weddingWebsite"
            i18nKey="rsvp.guest.common.deadlinePassedInfo">
            <p>The deadline for submitting your RSVP has passed.</p>
            <p>
              Please contact{' '}
              <strong>
                {'{{partners.0}}'} & {'{{partners.1}}'}
              </strong>{' '}
              directly if you need to update your response.
            </p>
          </Trans>
        </Box>
        <SubmitButtonDesktopWrapper>
          <GoToWebsiteButton websiteId={websiteId} searchParams={searchParams}>
            {t('rsvp.guest.deadlinePassed.cta.goToWebsite')}
          </GoToWebsiteButton>
        </SubmitButtonDesktopWrapper>
      </Box>
      <SubmitButtonMobileWrapper>
        <GoToWebsiteButton websiteId={websiteId} searchParams={searchParams}>
          {t('rsvp.guest.deadlinePassed.cta.goToWebsite')}
        </GoToWebsiteButton>
      </SubmitButtonMobileWrapper>
    </>
  );
};

export default DeadlinePassedStep;
